import { EventObject } from "../util/event/EventObject";
import { Locale } from "./manager/LanguageManager";
/**
 * Modules.ts
 */
export class Modules {
}
Modules.PRELOADER = "Preloader";
Modules.LOADER = "Loader";
Modules.GAME = "Game";
Modules.GAME_MASK = "GameMask";
Modules.ORIENTATION = "Orientation";
Modules.DIALOG_MANAGER = "DialogManager";
Modules.FULL_SCREEN = "FullScreen";
/**
 * Settings.ts
 */
export class Settings {
}
Settings.POST_ROTATE_DELAY = 0.5;
/**
 * UrlConstants.ts
 */
export class UrlConstants {
}
UrlConstants.PRIMARY_NODE = "primaryNode";
UrlConstants.LOCALE = "locale";
UrlConstants.CURRENCY = "currency";
UrlConstants.TEST = "test";
/**
 * AppEvent.ts
 */
export class AppEvent {
}
AppEvent.ERROR = new EventObject("AppEvent.ERROR");
AppEvent.ERROR_COMPLETE = new EventObject("AppEvent.ERROR_COMPLETE");
AppEvent.BALANCE = new EventObject("AppEvent.BALANCE");
AppEvent.SOUND_ON = new EventObject("AppEvent.SOUND_ON");
AppEvent.SOUND_OFF = new EventObject("AppEvent.SOUND_OFF");
AppEvent.EXIT_GAME = new EventObject("AppEvent.EXIT_GAME");
AppEvent.DEPOSIT = new EventObject("AppEvent.DEPOSIT");
AppEvent.BET_HISTORY = new EventObject("AppEvent.BET_HISTORY");
AppEvent.BONUS = new EventObject("AppEvent.BONUS");
AppEvent.IDLE = new EventObject("AppEvent.IDLE");
AppEvent.BUSY = new EventObject("AppEvent.BUSY");
AppEvent.SETTINGS_LOADED = new EventObject("AppEvent.SETTINGS_LOADED");
AppEvent.NON_RECOVERABLE_ERROR_COMPLETE = new EventObject("AppEvent.NON_RECOVERABLE_ERROR_COMPLETE");
AppEvent.WRAPPER_READY = new EventObject("AppEvent.WRAPPER_READY");
AppEvent.DYNAMIC_POPUP = new EventObject("AppEvent.DYNAMIC_POPUP");
/**
 * GameErrorEvent.ts
 */
export class GameErrorEvent {
}
GameErrorEvent.INSUFFICIENT_FUNDS = new EventObject("GameErrorEvent.INSUFFICIENT_FUNDS");
GameErrorEvent.SESSION_TIME_OUT = new EventObject("GameErrorEvent.SESSION_TIME_OUT");
GameErrorEvent.REALITY_CHECK = new EventObject("GameErrorEvent.REALITY_CHECK");
GameErrorEvent.REALITY_CHECK_CLOSE = new EventObject("GameErrorEvent.REALITY_CHECK_CLOSE");
GameErrorEvent.ACCOUNT_LIMIT_EXCEEDED = new EventObject("GameErrorEvent.ACCOUNT_LIMIT_EXCEEDED");
GameErrorEvent.CURRENCY_NOT_SUPPORTED = new EventObject("GameErrorEvent.CURRENCY_NOT_SUPPORTED");
GameErrorEvent.REGULATORY_MESSAGE = new EventObject("GameErrorEvent.REGULATORY_MESSAGE");
GameErrorEvent.WAGER_CASH = new EventObject("GameErrorEvent.WAGER_CASH");
GameErrorEvent.WAGER_BONUS = new EventObject("GameErrorEvent.WAGER_BONUS");
GameErrorEvent.ACCOUNT_LIMIT_EXCEEDED_GENERIC = new EventObject("GameErrorEvent.ACCOUNT_LIMIT_EXCEEDED_GENERIC");
GameErrorEvent.RESPONSIBLE_GAMING_TIME_LIMIT = new EventObject("GameErrorEvent.RESPONSIBLE_GAMING_TIME_LIMIT");
GameErrorEvent.UNKNOWN_PROMOTION_CODE = new EventObject("GameErrorEvent.UNKNOWN_PROMOTION_CODE");
GameErrorEvent.USER_NOT_AUTHENTICATED = new EventObject("GameErrorEvent.USER_NOT_AUTHENTICATED");
GameErrorEvent.GAME_ACCESS_DENIED = new EventObject("GameErrorEvent.GAME_ACCESS_DENIED");
GameErrorEvent.JACKPOT_ALREADY_WON = new EventObject("GameErrorEvent.JACKPOT_ALREADY_WON");
GameErrorEvent.CONNECTION_ERROR = new EventObject("GameErrorEvent.CONNECTION_ERROR");
GameErrorEvent.RESPONSIBLE_GAMING_TURNOVER_LIMIT = new EventObject("GameErrorEvent.RESPONSIBLE_GAMING_TURNOVER_LIMIT");
GameErrorEvent.RESPONSIBLE_GAMING_PRICE_THRESHOLD = new EventObject("GameErrorEvent.RESPONSIBLE_GAMING_PRICE_THRESHOLD");
GameErrorEvent.RESPONSIBLE_GAMING_LIMIT = new EventObject("GameErrorEvent.RESPONSIBLE_GAMING_LIMIT");
GameErrorEvent.RESTRICTED_TERRITORY = new EventObject("GameErrorEvent.RESTRICTED_TERRITORY");
/**
 * DeployType.ts
 */
export class DeployType {
    constructor(id) {
        this.id = id;
    }
    static getType(id) {
        return DeployType[id];
    }
    isWeb() {
        return this == DeployType.WEB;
    }
    isNative() {
        return this == DeployType.NATIVE;
    }
}
DeployType.WEB = new DeployType("WEB");
DeployType.NATIVE = new DeployType("NATIVE");
/**
 * LangConstants.ts
 */
export class LangConstants {
}
LangConstants.FALLBACK_LANG = Locale.ENGLISH;
LangConstants.COMMON_URL = "rgs/lang/common/";
LangConstants.GAME_URL = "rgs/lang/game/";
LangConstants.OPERATOR_URL = "rgs/lang/operator/";
//# sourceMappingURL=Constants.js.map